export default "__VITE_ASSET__6f941cc6__"